import styled from "styled-components"

export const WearableContaianer = styled.div`
    display: ${(props) => props.display};
    flex-direction: column;
    width: 536px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    background-color: #262626;
    z-index: 1;

    /* @media screen and (max-height: 900px){
        transform: scale(0.75);
        top: 0%;
        left: 30%;
        /* transform: translate(-50%, -50%); */
    }

    @media screen and (max-height: 900px){
        transform: scale(0.5);
        top: 0%;
        left: -25%;
        /* transform: translate(-50%, -50%); */
    } */
    
`
export const WearableContent = styled.div`
    color: #8c8c8c8c;
    margin: 32px;
`
export const WearableHead = styled.div`
    margin: 32px 32px 0px 32px;
    color: white;
    font-size: 20px;
    line-height: 24px;
    font-weight:bold;

`
export const IceExchange = styled.div`
    margin-top:20px;
    background-color: black;
    color: white;
    display:flex;
    text-align:center;
    justify-content:center;
    line-height: 15px;
    font-size: 12px;
    padding: 10px 0px;
`

export const WearableButtonContainer = styled.div`
    margin: 32px;
    display:grid;
    grid-template-columns: 50% 50%;
` 
export const WearableLabel = styled.div`
    display:flex;
    background-color:#262626;
    border: 1px #595959 solid;
    border-radius: 10px;
    height: 40px;
    padding: 10px 10px;
    color: #8c8c8c; 
    text-align:right;
    align-items:center;
    justify-content:space-between;
    font-size: 16px;
    line-height:19px;
    margin-top:30px;
`
export const LastWearableLabel = styled.div`
    display:flex;
    background-color:#595959;
    border: 1px #595959 solid;
    border-radius: 10px;
    height: 40px;
    padding: 10px 10px;
    color: #8c8c8c; 
    text-align:right;
    align-items:center;
    justify-content:space-between;
    font-size: 16px;
    line-height:19px;
    margin-top:30px;
`
export const SelectedInfo = styled.div`
    background-color:transparent;
    height: 100%;
    text-align:center;
    color:white;
    font-size: 16px;
    line-height:19px;
    display:flex;
    /* border: 2px red solid; */
    align-items:center;
`
export const LastSelectedInfo = styled.div`
    background-color:transparent;
    height: 100%;
    text-align:center;
    color:white;
    font-size: 16px;
    line-height:19px;
    display:flex;
    /* border: 2px red solid; */
    align-items:center;
`
export const RentInfo = styled.div`
    margin: 10px 32px;
    color: #8c8c8c8c;
    font-size:12px;
    text-align:center;

`
export const TestSpan = styled.span`
    color: #40a9ff;
    font-size:12px;

`
export const WearableCaption = styled.div`
    display: flex;
    margin: 30px 32px;
    align-items:center;
`
export const WearableImageContainer = styled.div`
    height:60px;
    width:60px;
    display: flex;
    justify-content:center;
    align-items:center;
    border: 1px #595959 solid;
    border-radius: 10px;
`
export const WearableImage = styled.img`
    height:50px;
    width:50px;
    border-radius:10px;
`
export const WearableTextContainer = styled.div`
    color: #8c8c8c;
    display:flex;
    flex-direction:column;
    justify-content:center;
    margin-left:20px;
`
export const WearableText1 = styled.div`
    font-size:16px;
    line-height:19px;
    color:white;
    font-weight:bold;
    
`
export const WearableText2 = styled.div`
    font-size:12px;
    line-height:15px;
    margin-top:5px;
`